export const projects = [
    {   
        id: 'porto_1',
        name: 'ChatApp',
        description: 'Is build with React and Socket.io, and backend on Node.js. Users can sign in and chat here.',
        link: 'https://react-chatting.netlify.app'
    },
    {   
        id: 'porto_2',
        name: 'Movie DB',
        description: 'This projest is build with Redux and Redux-thunk. Interface is created with Tailwind. It fetches data from MovieDB API.',
        link: 'https://dmetree.github.io/tt-moviedb/'
    },
    {   
        id: 'porto_3',
        name: 'Diletant',
        description: 'This project is build with React and Redux, it uses hardcoded data. Data can be filtered and searched through. Redux store is used as the single source of truth.',
        link: 'https://dmetree.github.io/tt-diletant/'
    },
    {   
        id: 'porto_4',
        name: 'Burger Builder',
        description: 'This is a codecamp by M.Swartzmuller. It is build with React and Redux-thunk, has user authentiacation and backend at firebase. Orders are stored in the backend.',
        link: 'https://dmetree.github.io/react-burger/'
    },
    {   
        id: 'porto_5',
        name: 'GameOfLife',
        description: 'Is built with React hooks and has some nice animatins. The idea of the game is inspired by Vladimir Baskakov. I`m still figuring out how to make it better',
        link: 'https://dmetree.github.io/life-game/'
    },
    {
        id: 'porto_6',
        name: 'DevStars',
        description: 'A social net for webDevelopers. One can create an account, fill in data about work, exp and education, make posts and comment on post of other devs or just see a list of devs.',
        link: 'https://boiling-sands-29677.herokuapp.com/'
    },
    {
        id: 'porto_7',
        name: 'CryptoStore',
        description: 'A catalogue of businesses accepting crypto for their services. React / Firebase',
        link: 'https://crypto-store-9e8de.web.app/'
    },
    {
        id: 'porto_8',
        name: 'CryptoGuide',
        description: 'A personal website + affiliate program. React / Firebase auth :: firestore :: hosting',
        link:  'https://crypto-guide-867b0.web.app/'
    },
    {
        id: 'porto_9',
        name: 'Coryphoena',
        description: 'Ecommerce website. Internent store. React / Hooks / Firebase: auth :: firestore :: react-storage :: react-hosting',
        link:  'https://coryphaena-42180.web.app/'
    },
   
]